import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withKeys as _withKeys, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mtrack__head" }
const _hoisted_2 = { class: "mtrack__meta" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "mtrack__ship" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "mtrack__tools" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["href"]
const _hoisted_9 = {
  key: 0,
  class: "mtrack__copied"
}
const _hoisted_10 = {
  key: 1,
  class: "mtrack__copied"
}
const _hoisted_11 = {
  key: 2,
  class: "mtrack__error"
}
const _hoisted_12 = {
  key: 3,
  class: "mtrack__note"
}
const _hoisted_13 = {
  key: 4,
  class: "mtrack__empty"
}
const _hoisted_14 = {
  key: 5,
  class: "mtrack__list"
}
const _hoisted_15 = { class: "mtrack__row-top" }
const _hoisted_16 = {
  key: 0,
  class: "mtrack__place"
}
const _hoisted_17 = {
  key: 1,
  class: "mtrack__desc"
}
const _hoisted_18 = {
  key: 6,
  class: "mtrack__empty"
}

import { computed, onMounted, ref } from 'vue'
import AppIcon from '@/components/common/AppIcon.vue'
import { fetchOrderItemTracking, fetchPublicParcelTracking, type MallTracking } from '@/api/mallOrder'
import { copyToClipboard } from '@/utils/clipboard'


export default /*@__PURE__*/_defineComponent({
  __name: 'MallTrackingModal',
  props: {
    itemIdx: {},
    courier: {},
    invoice: {},
    productName: {},
    orderCode: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const panelEl = ref<HTMLElement | null>(null)
const loading = ref(false)
const copied = ref(false)
const errorMessage = ref('')
const tracking = ref<MallTracking | null>(null)

const events = computed(() => {
  const list = [...(tracking.value?.events || [])]
  return list.sort((a, b) => {
    const left = new Date(a.at).getTime()
    const right = new Date(b.at).getTime()
    if (Number.isNaN(left) || Number.isNaN(right)) return 0
    return left - right
  })
})
const invoiceText = computed(() =>
  String(tracking.value?.invoice || props.invoice || '').replace(/\s+/g, ''),
)

function formatDateTime(value: string) {
  if (!value) return '-'
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return value
  const y = date.getFullYear()
  const m = String(date.getMonth() + 1).padStart(2, '0')
  const d = String(date.getDate()).padStart(2, '0')
  const h = String(date.getHours()).padStart(2, '0')
  const min = String(date.getMinutes()).padStart(2, '0')
  return `${y}.${m}.${d} ${h}:${min}`
}

async function load() {
  loading.value = true
  errorMessage.value = ''
  try {
    const invoice = String(props.invoice || '').replace(/\s+/g, '')
    /*
     * itemIdx 가 있으면 항상 인증 엔드포인트로 간다. 서버가 이 송장을 caion_mall_order_shipment
     * 에서 찾아 개별 추적 상태(mos_track_status / mos_delivered_at) 를 저장하기 때문에,
     * 이후 화면 새로고침 시 배송완료/배송중 배지가 그대로 유지된다.
     */
    if (props.itemIdx) {
      tracking.value = await fetchOrderItemTracking(props.itemIdx, {
        courier: props.courier,
        invoice,
      })
    } else if (invoice) {
      tracking.value = await fetchPublicParcelTracking(props.courier || '', invoice)
    } else {
      errorMessage.value = '배송조회에 필요한 정보가 부족합니다.'
    }
  } catch (error) {
    errorMessage.value = error instanceof Error ? error.message : '배송조회를 불러오지 못했습니다.'
  } finally {
    loading.value = false
  }
}

async function copyInvoice() {
  if (!invoiceText.value) return
  const ok = await copyToClipboard(invoiceText.value)
  if (!ok) {
    errorMessage.value = '송장번호 복사에 실패했습니다.'
    return
  }
  copied.value = true
  window.setTimeout(() => {
    copied.value = false
  }, 1600)
}

onMounted(() => {
  panelEl.value?.focus()
  void load()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: "mtrack",
      role: "dialog",
      "aria-modal": "true",
      "aria-labelledby": "mtrack-title",
      "data-tour": "mall-tracking-modal",
      onKeydown: _cache[2] || (_cache[2] = _withKeys(_withModifiers(($event: any) => (emit('close')), ["prevent"]), ["esc"]))
    }, [
      _createElementVNode("button", {
        type: "button",
        class: "mtrack__catch",
        "aria-label": "닫기",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
      }),
      _createElementVNode("div", {
        ref_key: "panelEl",
        ref: panelEl,
        class: "mtrack__panel",
        tabindex: "-1"
      }, [
        _createElementVNode("header", _hoisted_1, [
          _createElementVNode("div", null, [
            _cache[3] || (_cache[3] = _createElementVNode("h2", { id: "mtrack-title" }, "배송조회", -1)),
            _createElementVNode("p", _hoisted_2, [
              _createElementVNode("strong", null, _toDisplayString(tracking.value?.productName || __props.productName || '주문 상품'), 1),
              (tracking.value?.orderCode || __props.orderCode)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(tracking.value?.orderCode || __props.orderCode), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "mtrack__close",
            "aria-label": "닫기",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('close')))
          }, [
            _createVNode(AppIcon, {
              icon: "mdi-close",
              size: 20
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _cache[4] || (_cache[4] = _createElementVNode("span", null, "택배사", -1)),
            _createElementVNode("strong", null, _toDisplayString(tracking.value?.courier || __props.courier || '-'), 1)
          ]),
          _createElementVNode("div", null, [
            _cache[5] || (_cache[5] = _createElementVNode("span", null, "송장번호", -1)),
            _createElementVNode("strong", null, _toDisplayString(tracking.value?.invoice || __props.invoice || '-'), 1)
          ]),
          (tracking.value?.lastStatus)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _cache[6] || (_cache[6] = _createElementVNode("span", null, "현재 상태", -1)),
                _createElementVNode("strong", null, _toDisplayString(tracking.value.lastStatus), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            type: "button",
            class: "mtrack__tool",
            disabled: loading.value,
            onClick: load
          }, [
            _createVNode(AppIcon, {
              icon: "mdi-refresh",
              size: 16
            }),
            _createTextVNode(" " + _toDisplayString(loading.value ? '조회 중…' : '다시 조회'), 1)
          ], 8, _hoisted_7),
          (invoiceText.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "mtrack__tool",
                onClick: copyInvoice
              }, [
                _createVNode(AppIcon, {
                  icon: "mdi-content-copy",
                  size: 16
                }),
                _cache[7] || (_cache[7] = _createTextVNode(" 송장 복사 ", -1))
              ]))
            : _createCommentVNode("", true),
          (tracking.value?.sourceUrl)
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                class: "mtrack__tool",
                href: tracking.value.sourceUrl,
                target: "_blank",
                rel: "noopener"
              }, [
                _createVNode(AppIcon, {
                  icon: "mdi-open-in-new",
                  size: 16
                }),
                _cache[8] || (_cache[8] = _createTextVNode(" 택배사 사이트 ", -1))
              ], 8, _hoisted_8))
            : _createCommentVNode("", true)
        ]),
        (copied.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_9, "송장번호를 복사했습니다."))
          : _createCommentVNode("", true),
        (tracking.value?.delivered)
          ? (_openBlock(), _createElementBlock("p", _hoisted_10, "도착이 확인되어 주문 상태를 배송완료로 반영합니다."))
          : _createCommentVNode("", true),
        (errorMessage.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(errorMessage.value), 1))
          : (tracking.value?.message)
            ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(tracking.value.message), 1))
            : _createCommentVNode("", true),
        (loading.value && !tracking.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createVNode(AppIcon, {
                icon: "mdi-loading",
                size: 24
              }),
              _cache[9] || (_cache[9] = _createElementVNode("p", null, "배송일지를 불러오는 중입니다…", -1))
            ]))
          : (events.value.length)
            ? (_openBlock(), _createElementBlock("ol", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(events.value, (event, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: `${event.at}-${index}`,
                    class: _normalizeClass({ 'is-latest': index === events.value.length - 1 })
                  }, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("strong", null, _toDisplayString(event.status || '처리'), 1),
                      _createElementVNode("time", null, _toDisplayString(formatDateTime(event.at)), 1)
                    ]),
                    (event.location)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(event.location), 1))
                      : _createCommentVNode("", true),
                    (event.description)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(event.description), 1))
                      : _createCommentVNode("", true)
                  ], 2))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createVNode(AppIcon, {
                  icon: "mdi-truck-outline",
                  size: 28
                }),
                _cache[10] || (_cache[10] = _createElementVNode("p", null, "아직 표시할 배송일지가 없습니다.", -1))
              ]))
      ], 512)
    ], 32)
  ]))
}
}

})